import { TriangleAlert } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

/**
 * Banner shown on video events whose media URL is a YouTube link instead of
 * a real media or m3u8 file. YouTube links violate NIP-71 and work against
 * the decentrality of Nostr.
 */
export function YouTubeWarningBanner() {
  return (
    <Alert variant="destructive" className="border-yellow-600/50 bg-yellow-600/10 text-yellow-700 dark:text-yellow-500 [&>svg]:text-yellow-600 dark:[&>svg]:text-yellow-500">
      <TriangleAlert className="h-4 w-4" />
      <AlertTitle>YouTube link detected</AlertTitle>
      <AlertDescription className="text-yellow-700/90 dark:text-yellow-500/90">
        This video event links to YouTube instead of a media or m3u8 file.
        YouTube links are against NIP-71 and undermine the decentrality of
        Nostr — the video depends on a centralized, censorable platform.
        Consider re-uploading the media file to a Blossom server.
      </AlertDescription>
    </Alert>
  );
}
